import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { distinctUntilChanged, filter, map } from 'rxjs';
import {
  ReferenceQuestionState,
  ReferenceQuestionStoreModel,
  ReferenceQuestionUIModel,
} from './reference-question.model';
import { ReferenceQuestionStore } from './reference-question.store';

@Injectable({ providedIn: 'root' })
export class ReferenceQuestionQuery extends QueryEntity<
  ReferenceQuestionState,
  ReferenceQuestionStoreModel,
  ReferenceQuestionUIModel,
  'id'
> {
  constructor(protected override store: ReferenceQuestionStore) {
    super(store);
  }

  readonly questionItems$ = this.selectActive().pipe(
    filter(Boolean),
    map((refQuestion) => refQuestion.question_items ?? []),
    distinctUntilChanged((prev, curr) => {
      if (!prev || !curr) {
        return prev === curr;
      }
      return JSON.stringify(prev) === JSON.stringify(curr);
    }),
  );

  override readonly toUIModelFn = (entity: ReferenceQuestionStoreModel) => {
    return {
      ...entity,
      created_at: `${entity.created_at}Z`,
    };
  };
}
